import { Modal as AntdModal } from "antd";
import { useModal } from "../context/ModalContext";
import { useIsSmallScreen } from "../utils/useMediaQuery";

export default function Modal() {
    const isSmallScreen = useIsSmallScreen(992);
    const { modal, closeModal } = useModal();

    // Tam ekran artık başlıktaki düğmeyle açılıp kapanan, localStorage'da saklanan ve TÜM
    // modalları etkileyen bir tercih değil: yalnız openFullScreenModal ile açılan ekranlara özel.
    // (Düğme aynı zamanda antd'nin kendi kapatma düğmesiyle çakışıp hizayı bozuyordu.)
    const isFullScreen = !!modal.fullScreen;

    // Dikeyde ortalanır (üstten %20 boşluk kaldırıldı). Yükseklik viewport'a göre sınırlı;
    // uzun içerik alta kadar dolar, kısa içerik ortalanır.
    const bodyMaxHeight = 'calc(100vh - 100px)';

    // Çağıran açıkça `width` geçmediyse modal kendi İÇERİĞİ kadar geniş olur (`fit-content`).
    // Eski varsayılan pencerenin %60'ıydı: 2560px'lik bir ekranda üç alanlık bir form bile
    // 1500px'e yayılıyordu. Alt sınır antd'nin kendi varsayılan modal genişliği (520) — içeriği
    // dar diye hiçbir modal iğne gibi kalmasın; üst sınır geniş içerik ekranı yutmasın diye.
    // Daha geniş gerekiyorsa çağıran eskisi gibi openModal(..., width) geçer.
    const CONTENT_WIDTH = 'fit-content';
    const contentWidthStyle = { minWidth: 520, maxWidth: 'min(92vw, 1100px)' };

    return (
        <div>
            {
                modal.open && (
                    <AntdModal
                        // openId her açılışta değişir → içerik taze mount olur (bayat component sorunu çözülür,
                        // eski setTimeout gecikmesine/boş-yanıp-sönmeye gerek kalmaz).
                        key={modal.openId}
                        destroyOnClose
                        centered={!isFullScreen && !isSmallScreen}
                        style={
                            isFullScreen
                                ? { top: 0, margin: 0, padding: 0, maxWidth: '100vw', height: '100vh' }
                                : (isSmallScreen
                                    ? { top: 10, margin: 10, maxWidth: 'calc(100% - 20px)' }
                                    : (modal.width ? {} : contentWidthStyle))
                        }
                        width={isFullScreen ? '100%' : (isSmallScreen ? '100%' : (modal.width || CONTENT_WIDTH))}
                        open={modal.open}
                        title={modal.title}
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                        bodyStyle={
                            isFullScreen
                                ? { height: 'calc(100vh - 55px)', overflowY: 'auto' }
                                // overflowX: içerik üst sınırdan genişse modal kutusunun dışına
                                // taşmak yerine kendi içinde yatay kaysın.
                                : { maxHeight: bodyMaxHeight, overflowY: 'auto', overflowX: 'auto' }
                        }
                    >
                        {modal.component}
                    </AntdModal>
                )
            }
            {
                modal?.modal2?.open && (
                    <AntdModal
                        key={`m2-${modal.openId}`}
                        destroyOnClose
                        // İkincil modal de içeriği kadar (eskiden sabit %50); alttaki modalı
                        // gereksiz yere örtmesin diye üst sınırı biraz daha dar.
                        style={isSmallScreen ? { marginTop: 24 } : { marginTop: 24, minWidth: 520, maxWidth: 'min(88vw, 900px)' }}
                        width={isSmallScreen ? '100%' : CONTENT_WIDTH}
                        open={modal.modal2.open}
                        title={modal.modal2.title}
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                        bodyStyle={{ maxHeight: 'calc(85vh - 55px)', overflowY: 'auto' }}
                    >
                        {modal.modal2.component}
                    </AntdModal>
                )
            }
        </div>
    )
}
